import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CTAButton from '../../../CTAButton';
import BackButton from '../../shared/BackButton';
import { decrementStep, incrementStep } from '../redux/action';

const Step3 = () => {
  const formData = useSelector(state => state.formData);
  const metadata = useSelector(state => state.metadata);
  const dispatch = useDispatch();

  const { street, city, state, zip } = formData.propertyAddress;
  const { warrantyDetails } = metadata;

  return (
    <div>
      <BackButton
        analytics={{
          'data-track': 'form-back',
          'data-track-form-name': 'Submit Claim',
          'data-track-form-step': 'step 3 - customer warranty and details',
        }}
        onClick={() => dispatch(decrementStep())}
        backText="Please read and accept our terms of service."
      />
      <p className="mb20">Below you’ll find some information on your warranty details.</p>

      <h4>Customer Warranty and Details</h4>
      <p className="mb10">According to our records, these are the details we have for your roof warranty:</p>

      <div className="txtContainer">
        <h4>Property Owner Name</h4>
        <p className="mb10">
          {warrantyDetails?.property_information?.first_name} {warrantyDetails?.property_information?.last_name}
        </p>
      </div>

      <div className="txtContainer">
        <h4>Property Address</h4>
        <p className="mb10">
          {street} {city}, {state} {zip}
        </p>
      </div>

      <div className="txtContainer">
        <h4>Installation Date</h4>
        <p className="mb10">{warrantyDetails?.product_information?.date_of_installation}</p>
      </div>

      <div className="txtContainer">
        <h4>Shingles Installed</h4>
        <p className="mb10">{warrantyDetails?.product_information?.product}</p>
      </div>

      <div className="txtContainer">
        <h4>Shingle Color</h4>
        <p className="mb10">{warrantyDetails?.product_information?.color}</p>
      </div>

      <div className="txtContainer mb20">
        <h4>Roof Size</h4>
        <p>Number of Squares Installed: {warrantyDetails?.product_information?.square_installed}</p>
      </div>

      <div className="editBtn2 mt10">
        <span>If the above information is incorrect, please contact 1-800-ROOFING.</span>
      </div>

      <CTAButton
        onClick={() => dispatch(incrementStep())}
        data-track="form-advance"
        data-track-form-name="Submit Claim"
        data-track-form-step="step 3 - customer warranty and details"
        element="button"
        text="Continue With Claim"
        type="submit"
      />
    </div>
  );
};

export default Step3;
